import http from "../http-common";

class HardwareAssetDataService {

    getAssets(askerId, offsetValue, selectedType, warrantyStatus, expirationStartDate, expirationEndDate, selectedAssignedToUser, serialNumber, assetTag, searchText, sortBy, sortOrder, selectedTenantId, siteId, state, modelId) {
        return http.get(`/hardwareAssets?askerId=${askerId}&offsetValue=${offsetValue}&selectedType=${selectedType}&warrantyStatus=${warrantyStatus}&expirationStartDate=${expirationStartDate}&expirationEndDate=${expirationEndDate}&selectedAssignedToUser=${selectedAssignedToUser}&serialNumber=${serialNumber}&assetTag=${assetTag}&searchText=${searchText}&sortBy=${sortBy}&sortOrder=${sortOrder}&selectedTenantId=${selectedTenantId}&siteId=${siteId}&state=${state}&modelId=${modelId}`);
    }

    getSpecificAsset(assetId, timezoneAdjustmentFactor) {
        return http.get(`/hardwareAssets/getSpecific/${assetId}?timezoneAdjustmentFactor=${timezoneAdjustmentFactor}`);
    }

    getHistory(id, timeZoneAdjustmentFactor) {
        return http.get(`/hardwareAssets/getHistory/${id}?timezoneAdjustmentFactor=${timeZoneAdjustmentFactor}`);
    }

    getSpecificHistoryEventDetails(historyEventId, timeZoneAdjustmentFactor) {
        return http.get(`/hardwareAssets/getSpecificHistoryEventDetails/${historyEventId}?timeZoneAdjustmentFactor=${timeZoneAdjustmentFactor}`);
    }

    // get the list of type names and id numbers for the filter drop down menu
    getTypes(customer_id) {
        return http.get(`/hardwareAssets/types?tenantId=${customer_id}`);
    }

    // get the list of users tech is authorized to see for the filter drop down menu
    getUsers(asker_id, tenant_id) {
        return http.get(`/hardwareAssets/users?userIdAsking=${asker_id}&tenantId=${tenant_id}`);
    }

    // get the list of users for the add hardware asset assign user drop down (only going to see one tenant at a time unlike view assets version)
    getUsersAddAssetVersion(asker_id, tenant_id) {
        return http.get(`/hardwareAssets/usersAddAssetVersion?userIdAsking=${asker_id}&tenantId=${tenant_id}`);
    }

    // get the list of a user's assigned hardware assets for the SOFTWARE assets filter drop down menu
    getUsersAssignedHardwareAssets(assignedPersonId, tenantId) {
        return http.get(`/hardwareAssets/usersAssignedHardwareAssets?assignedPersonId=${assignedPersonId}&tenantId=${tenantId}`);
    }

    // get the list of tenant names the tech is authorized to see for the filter drop down menu
    getTenants(asker_id) {
        return http.get(`/hardwareAssets/tenants?userIdAsking=${asker_id}`);
    }

    // get the list of categories for add hardware asset drop down menu
    getCategories() {
        return http.get("/hardwareAssets/categories");
    }

    // get the list of vendors for add hardware asset drop down menu
    getVendors(tenantId) {
        return http.get(`/hardwareAssets/vendors?tenantId=${tenantId}`);
    }

    // get the list of manufacturers for add hardware asset drop down menu
    getManufacturers(tenantIdSelected) {
        return http.get(`/hardwareAssets/manufacturers?tenantId=${tenantIdSelected}`);
    }

    // get the list of models based on the type the user has selected in asset type drop down menu
    getModels(typeId, manufacturerId) {
        return http.get(`/hardwareAssets/models?typeId=${typeId}&manufacturerId=${manufacturerId}`);
    }

    // get all the models associated with the given tenant for use in the models dropdown filter
    getModelsForFilterDropdown(tenantId) {
        return http.get(`/hardwareAssets/getModelsForFilterDropdown?tenantId=${tenantId}`);
    }

    // get the list of sites based on the company the user has selected in company drop down menu
    getSites(tenantId) {
        return http.get(`/hardwareAssets/sites?tenantId=${tenantId}`);
    }

    // get the list of locations in building based on site selected
    getLocations(siteId) {
        return http.get(`/hardwareAssets/locations?siteId=${siteId}`);
    }

    // get the list of assignable assets based on type, category and company selected in add hardware asset form
    getAssignableAssets(tenantId, typeId, categoryId) {
        return http.get(`/hardwareAssets/assignableAssets?tenantId=${tenantId}&typeId=${typeId}&categoryId=${categoryId}`);
    }

    // get the list of departments for the selected tenant
    getDepartments(tenantId) {
        return http.get(`/hardwareAssets/getDepartments?tenantId=${tenantId}`);
    }

    getManagingGroups(tenantId) {
        return http.get(`/hardwareAssets/getManagingGroups?tenantId=${tenantId}`);
    }

    // check for duplicate hardware asset name before submitting the complete form to backend
    checkForDuplicateAssetName(assetName, tenantId) {
        return http.get(`/hardwareAssets/checkForDuplicateAssetName?assetName=${assetName}&tenantId=${tenantId}`);
    }

    // check for duplicate hardware asset name before submitting edit form
    checkForDuplicateAssetNameEditVersion(assetName, assetId, tenantId) {
        return http.get(`/hardwareAssets/checkForDuplicateAssetNameEditVersion?assetName=${assetName}&assetId=${assetId}&tenantId=${tenantId}`);
    }

    // check for duplicate asset category name before submitting the form to backend
    checkForDuplicateCategoryName(categoryName) {
        return http.get(`/hardwareAssets/checkForDuplicateCategoryName?categoryName=${categoryName}`);
    }

    // check for duplicate asset type name before submitting the form to backend
    checkForDuplicateTypeName(typeName, tenantId) {
        return http.get(`/hardwareAssets/checkForDuplicateTypeName?typeName=${typeName}&tenantId=${tenantId}`);
    }

    // check for duplicate model name before submitting the form to backend
    checkForDuplicateModelName(modelName) {
        return http.get(`/hardwareAssets/checkForDuplicateModelName?modelName=${modelName}`);
    }

    // check for duplicate manufacturer before submitting the form to backend
    checkForDuplicateManufacturer(manufacturerName, manufacturerType, tenantId) {
        return http.get(`/hardwareAssets/checkForDuplicateManufacturer?manufacturerName=${manufacturerName}&manufacturerType=${manufacturerType}&tenantId=${tenantId}`);
    }

    // check for duplicate site before submitting the form to backend
    checkForDuplicateSiteName(siteName, tenantId) {
        return http.get(`/hardwareAssets/checkForDuplicateSiteName?siteName=${siteName}&tenantId=${tenantId}`);
    }

    // check for duplicate location before submitting the form to backend
    checkForDuplicateLocation(floorNumber, aisleNumber, deskNumber, siteId) {
        return http.get(`/hardwareAssets/checkForDuplicateLocationInfo?floorNumber=${floorNumber}&aisleNumber=${aisleNumber}&deskNumber=${deskNumber}&siteId=${siteId}`);
    }

    // check for duplicate vendor before submitting the form to backend
    checkForDuplicateVendor(vendorName, tenantId) {
        return http.get(`/hardwareAssets/checkForDuplicateVendor?vendorName=${vendorName}&tenantId=${tenantId}`);
    }

    // check for dupliate department before submitting the form to backend
    checkForDuplicateDepartment(departmentName, tenantId) {
        return http.get(`/hardwareAssets/checkForDuplicateDepartment?name=${departmentName}&tenantId=${tenantId}`);
    }

    checkForDuplicateManagingGroup(groupName, tenantId) {
        return http.get(`/hardwareAssets/checkForDuplicateManagingGroup?name=${groupName}&tenantId=${tenantId}`);
    }

    // get hardware orders for the main table page
    getHardwareOrders(askerId, selectedTenantId, sortBy, sortOrder, offsetValue, timespan, status, searchText) {
        return http.get(`/hardwareAssets/getHardwareOrders?askerId=${askerId}&selectedTenantId=${selectedTenantId}&sortBy=${sortBy}&sortOrder=${sortOrder}&offsetValue=${offsetValue}&timespan=${timespan}&status=${status}&searchText=${searchText}`);
    }

    // get a specific hardware order
    getSpecificHardwareOrder(id, askerId, productSortBy, productSortOrder) {
        return http.get(`/hardwareAssets/getHardwareOrderDetails?id=${id}&askerId=${askerId}&productSortBy=${productSortBy}&productSortOrder=${productSortOrder}`);
    }

    // get the tenant wide settings for hardware asset fields to show / hide
    getHardwareAssetFieldSettings(tenantId) {
        return http.get(`/hardwareAssets/getHardwareAssetFieldSettings?tenantId=${tenantId}`);
    }

    // create a new hardware asset
    createNewHardwareAsset(data, creatorId) {
        return http.post(`/hardwareAssets?creatorId=${creatorId}`, data);
    }

    // edit existing hardware asset
    editHardwareAsset(data, assetId, editorId) {
        return http.post(`/hardwareAssets/editHardwareAsset/${assetId}?assetId=${assetId}&editorId=${editorId}`, data);
    }

    // edit existing product(s) in an order
    editOrderProducts(data) {
        return http.post(`/hardwareAssets/updateProductsInHardwareOrders`, data);
    }


    // create a new asset category
    createCategory(data) {
        return http.post('/hardwareAssets/createCategory', data);
    }

    // create a new asset type
    createType(data) {
        return http.post('/hardwareAssets/createType', data);
    }

    // create a new model
    createModel(data) {
        return http.post('/hardwareAssets/createModel', data);
    }

    // create a new manufacturer
    createManufacturer(data) {
        return http.post('/hardwareAssets/createManufacturer', data);
    }

    // create a new site
    createSite(data) {
        return http.post('/hardwareAssets/createSite', data);
    }

    // create a new location
    createLocation(data) {
        return http.post('/hardwareAssets/createLocation', data);
    }

    // create a new vendor
    createVendor(data) {
        return http.post('/hardwareAssets/createVendor', data);
    }

    // create a new history event
    createHistoryEvent(data) {
        return http.post('/hardwareAssets/createHistoryEvent', data);
    }

    // create a hardware order
    createHardwareOrder(data) {
        return http.post('/hardwareAssets/createHardwareOrder', data);
    }

    // create a department
    createDepartment(data) {
        return http.post('/hardwareAssets/addDepartment', data);
    }

    createManagingGroup(data) {
        return http.post('/hardwareAssets/addManagingGroup', data);
    }

    // this is a delete operation, but I'm using the post method to have access ot the req.body parameter
    deleteOrderProducts(data) {
        return http.post('/hardwareAssets/deleteOrderProducts', data);
    }

    addProductsToOrder(data) {
        return http.post('/hardwareAssets/addProductsToOrder', data);
    }

    deleteEntireOrder(data) {
        return http.post('/hardwareAssets/deleteEntireOrder', data);
    }

    editHardwareOrder(data) {
        return http.post('/hardwareAssets/editHardwareOrder', data);
    }

    createAssetNote(data) {
        return http.post('/hardwareAssets/createAssetNote');
    }

    createAssetNote(data) {
        return http.post('/hardwareAssets/createAssetNote', data);
    }

    // getAll() {
    //     return http.get("/accounts");
    // }

    // create(data) {
    //     return http.post("/accounts", data);
    // }

    // get(id) {
    //     return http.get(`/accounts/${id}`);
    // }

    // update(id, data) {
    //     return http.put(`/accounts/${id}`, data);
    // }

    // delete(id) {
    //     return http.delete(`/accounts/${id}`);
    // }

    // findByName(name) {
    //     return http.get(`/accounts?name=${name}`);
    // }

}


export default new HardwareAssetDataService();